import { formatDateTime } from '@juvare/common-web-ui/utils';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { getDefaultPermissions } from '../../../../backend/features/permissions';
import { FileTypeIcon } from '../../../components/FileTypeIcon';
import { useDocumentLibraryTranslations } from '../../../hooks';
import { humanReadableFileSize } from '../../../utils';
export const useSelectFilesDialogColumns = () => {
    const { t } = useDocumentLibraryTranslations();
    return [
        {
            sortKey: 'name',
            headerLabel: t('documentPanel.name'),
            cellFunction: (row) => (React.createElement(Box, { sx: { display: 'flex' } },
                React.createElement(Box, { sx: { display: 'flex', px: 2 } },
                    React.createElement(FileTypeIcon, { row: row, defaultPermissions: getDefaultPermissions() })),
                React.createElement(Typography, { sx: { wordBreak: 'break-word' } }, row.columns.name))),
            tableCellHeadSx: {
                paddingLeft: 4,
            },
        },
        {
            headerLabel: t('documentPanel.lastUpdated'),
            cellFunction: (row) => React.createElement(Typography, null, formatDateTime(new Date(row.updated))),
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
        },
        {
            sortKey: 'ownerDisplayName',
            headerLabel: t('documentPanel.owner'),
            cellFunction: (row) => React.createElement(Typography, { sx: { wordBreak: 'break-word' } }, row.columns.ownerDisplayName),
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
        },
        {
            sortKey: 'contentLength',
            headerLabel: t('common.size'),
            cellFunction: (row) => (row.columns.contentLength !== undefined ? humanReadableFileSize(row.columns.contentLength) : ''),
            tableCellSx: {
                display: {
                    xs: 'none',
                    sm: 'table-cell',
                },
            },
        },
    ];
};
